import { createSuccessNotification, createErrorNotification, } from "../toaster/creators";
import { addNotification } from "../toaster/actions";
import { Observable } from "rxjs";
import { actions } from "./PendingValues";
const successNotification = createSuccessNotification("Copy dataset settings were updated successfully");
const errorNotification = createErrorNotification("Could not modify Archive copy dataset settings");
export function createNotificationOnCreateEpic(actionKeys) {
    return (actions$) => actions$
        .ofType(actionKeys.FINISH)
        .mergeMap(() => Observable.of(addNotification(successNotification)));
}
export function createNotificationOnCreateErrorEpic(actionKeys) {
    return (actions$) => actions$
        .ofType(actionKeys.ERROR)
        .mergeMap(() => Observable.of(addNotification(errorNotification)));
}
export function registerIncorrectValue(actionKeys) {
    return (actions$) => actions$
        .ofType(actionKeys.ERROR)
        .mergeMap((action) => Observable.of(actions.error({ index: action.config.index })));
}
export function registerFinishedValue(actionKeys) {
    return (actions$) => actions$
        .ofType(actionKeys.FINISH)
        .mergeMap((action) => Observable.of(actions.finish({ index: action.config.index })));
}
//# sourceMappingURL=updateNotification.js.map